import { apiGet, apiPostPut, apiDelete } from "./api_methods";
import { RECRUITER_LABELS_BASE } from "./endpoints";

/**
 * Create a new label (POST /v1/recruiter/labels).
 * @param {Object} body - Label data { name, color }
 * @returns {Promise<{ body, status }>}
 */
export async function createLabel(body) {
  return apiPostPut(body, RECRUITER_LABELS_BASE, "POST");
}

/**
 * Get all labels for the authenticated recruiter (GET /v1/recruiter/labels).
 * Returns all non-deleted labels with deeply populated linked entities.
 * @returns {Promise<{ body, status }>}
 */
export async function getLabels() {
  return apiGet(RECRUITER_LABELS_BASE);
}

/**
 * Get labels with masked PII for unverified recruiters (GET /v1/recruiter/labels/masked).
 * @returns {Promise<{ body, status }>}
 */
export async function getLabelsMasked() {
  return apiGet(`${RECRUITER_LABELS_BASE}/masked`);
}

/**
 * Generate basic starter labels (POST /v1/recruiter/labels/generate-basic).
 * Creates a default set of labels for the recruiter.
 * @returns {Promise<{ body, status }>}
 */
export async function generateBasicLabels() {
  return apiPostPut({}, `${RECRUITER_LABELS_BASE}/generate-basic`, "POST");
}

/**
 * Update labels for candidates or entities (PUT /v1/recruiter/labels/candidates).
 * @param {Object} body - Update data:
 *   - section: string (required) - One of: resumeSorting, jobPost, interview, mockTest, application, candidate
 *   - id: string (required) - ObjectId of the entity being labeled
 *   - add: string | string[] - Label ID(s) to add
 *   - remove: string | string[] - Label ID(s) to remove
 * @returns {Promise<{ body, status }>}
 */
export async function updateLabelsForCandidates(body) {
  return apiPostPut(body, `${RECRUITER_LABELS_BASE}/candidates`, "PUT");
}

/**
 * Update a label (PUT /v1/recruiter/labels/:id).
 * @param {string} labelId - Label ObjectId
 * @param {Object} body - Fields to update { name?, color? }
 * @returns {Promise<{ body, status }>}
 */
export async function updateLabel(labelId, body) {
  return apiPostPut(body, `${RECRUITER_LABELS_BASE}/${labelId}`, "PUT");
}

/**
 * Delete a label (DELETE /v1/recruiter/labels/:id).
 * Soft-deletes the label (isDeleted: true).
 * @param {string} labelId - Label ObjectId
 * @returns {Promise<{ body, status }>}
 */
export async function deleteLabel(labelId) {
  return apiDelete(`${RECRUITER_LABELS_BASE}/${labelId}`);
}
